import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

export function ViewAllLink({ to, onClick, children = "View all", testId }) {
  const className = "text-sm font-medium text-accent hover:underline inline-flex items-center gap-1 shrink-0";
  const content = (
    <>
      {children} <ArrowRight className="h-3.5 w-3.5" />
    </>
  );
  if (to) {
    return <Link to={to} data-testid={testId} className={className}>{content}</Link>;
  }
  return <button type="button" data-testid={testId} onClick={onClick} className={className}>{content}</button>;
}

export default function SectionCard({ title, action, className, children, testId }) {
  return (
    <section
      data-testid={testId}
      className={cn("bg-card border border-border rounded-2xl p-5 sm:p-6 hi-animate-fade-up", className)}
    >
      <div className="flex items-center justify-between gap-3 mb-4">
        <h2 className="font-heading text-xl sm:text-2xl text-foreground">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
}
